import { Card, Flex, Typography } from 'antd';
import React from 'react';
import { useTelegram } from '../context/TelegramContext';
import { openTelegramLink } from '../utils/telegramLink';

const UZDEVID_URL = 'https://t.me/uzdevid';

interface OnboardingShellProps {
    title: string;
    subtitle?: string;
    backButton?: React.ReactNode;
    children: React.ReactNode;
}

const OnboardingShell = ({ title, subtitle, backButton, children }: OnboardingShellProps) => {
    const { webApp } = useTelegram();

    const openUzDevid = (event: React.MouseEvent<HTMLAnchorElement>) => openTelegramLink(webApp, UZDEVID_URL, event);

    return (
        <div className="onboarding-shell">
            <Card className="onboarding-card" bordered={false}>
                <Flex vertical gap={6}>
                    <Flex align="center" gap={8}>
                        {backButton}
                        <Typography.Title level={3} className="onboarding-title">
                            {title}
                        </Typography.Title>
                    </Flex>
                    {subtitle && <Typography.Paragraph className="onboarding-subtitle">{subtitle}</Typography.Paragraph>}
                </Flex>
                {children}
            </Card>
            <div className="app-footer">
                powered by{' '}
                <a
                    className="app-footer__link"
                    href={UZDEVID_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={openUzDevid}
                >
                    UzDevid
                </a>
            </div>
        </div>
    );
};

export default OnboardingShell;
